module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? [_c('pl-spinner', {
    staticClass: "x2 mt10",
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto",
      "margin-top": "200px"
    }
  })] : [_c('div', {
    staticClass: "row col-xs no-padding no-margin justify-end"
  }, [_c('pl-button', {
    staticClass: "remove-selected-users pl-ruby",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "disabled": !_vm.selectedCourses.length
    },
    nativeOn: {
      "click": function($event) {
        return _vm.removeCourses.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        Remove Selected Courses\n      ")])], 1), _vm._v(" "), (_vm.coursesList.length) ? _c('span', [_vm._v(_vm._s(_vm.schoolCoursesCount) + " / " + _vm._s(_vm.totalSchoolCourses) + " Courses")]) : _vm._e(), _vm._v(" "), (_vm.coursesList) ? _c('table', {
    staticClass: "users-table mv3 w-100"
  }, [_c('thead', [_c('tr', {
    staticClass: "row"
  }, [_c('td', {
    staticClass: "col-xs-1 b"
  }, [_c('pl-checkbox', {
    staticClass: "col-xs-1",
    on: {
      "change": _vm.selectAll
    },
    model: {
      value: (_vm.allSelected),
      callback: function($$v) {
        _vm.allSelected = $$v
      },
      expression: "allSelected"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "col-xs-3 b"
  }, [_vm._v("Course Name")]), _vm._v(" "), _c('td', {
    staticClass: "col-xs-3 b"
  }, [_vm._v("Teacher")]), _vm._v(" "), _c('td', {
    staticClass: "col-xs-2 b"
  }, [_vm._v("RTs")]), _vm._v(" "), _c('td', {
    staticClass: "col-xs-2 b"
  }, [_vm._v("Status")])])]), _vm._v(" "), (_vm.coursesList.length > 0 && !_vm.loadingTable) ? _c('tbody', {
    attrs: {
      "id": "admin-portal-course-table"
    },
    on: {
      "scroll": function($event) {
        return _vm.$emit('scroll-on-table')
      }
    }
  }, _vm._l((_vm.coursesList), function(course, index) {
    return _c('tr', {
      key: index,
      staticClass: "row"
    }, [_c('td', {
      staticClass: "col-xs-1"
    }, [_c('pl-checkbox', {
      staticClass: "col-xs-1",
      attrs: {
        "id": course.id
      },
      on: {
        "change": _vm.checkAllSelected
      },
      model: {
        value: (course.selected),
        callback: function($$v) {
          _vm.$set(course, "selected", $$v)
        },
        expression: "course.selected"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "col-xs-3 flex"
    }, [_c('span', {
      staticClass: "name-cell cursor-pointer truncate",
      on: {
        "click": function($event) {
          return _vm.openCourseDetails(course)
        }
      }
    }, [_vm._v("\n              " + _vm._s(course.title) + "\n            ")])]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-3 email-cell"
    }, [(course.teacher_email) ? _c('span', {
      staticClass: "truncate"
    }, [_vm._v("\n              " + _vm._s(course.teacher_email) + "\n            ")]) : _c('span', {
      staticClass: "ruby b"
    }, [_vm._v(" No Teacher(s) ")])]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-2"
    }, [_vm._v(_vm._s(course.number_rts))]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-2"
    }, [_vm._v("\n            " + _vm._s(course.is_archived ? 'Archived' : 'Active') + "\n          ")]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-1"
    }, [_c('pl-menu', {
      attrs: {
        "menuSize": 3,
        "direction": "right"
      }
    }, [_c('pl-button', {
      staticClass: "pl-icon",
      attrs: {
        "slot": "menu_trigger"
      },
      slot: "menu_trigger"
    }, [_c('i', {
      staticClass: "fa fa-ellipsis-v",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('ul', {
      attrs: {
        "menu-content": ""
      }
    }, [_c('li', {
      on: {
        "click": function($event) {
          return _vm.archiveCourseFromTable(course)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(course.is_archived ? 'Restore' : 'Archive') + " Course\n                ")]), _vm._v(" "), _c('li', {
      staticStyle: {
        "color": "#e53935"
      },
      on: {
        "click": function($event) {
          return _vm.deleteCourseFromTable(course)
        }
      }
    }, [_vm._v("\n                  Delete Course\n                ")])])], 1)], 1)])
  }), 0) : (_vm.coursesList.length == 0) ? _c('div', {
    staticClass: "center-xs b no-users-style"
  }, [_vm._v("\n        No Courses.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.loadingTable) ? _c('div', {
    key: "loading",
    staticClass: "flex center-xs middle-xs h-inherit"
  }, [_c('pl-spinner')], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.selected_course) ? _c('course-details-modal', {
    attrs: {
      "courseSelected": _vm.selected_course,
      "teachers": _vm.teachers
    },
    on: {
      "close": function($event) {
        _vm.selected_course = null
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_delete_course_modal) ? _c('dialog-delete-confirm', {
    attrs: {
      "header": _vm.deleteHeader,
      "subHeader": _vm.deleteSubHeader,
      "labelText": _vm.deleteLabelText,
      "optionalText": _vm.optional_text
    },
    on: {
      "close": function($event) {
        _vm.show_delete_course_modal = false
      },
      "actionConfirmed": _vm.deleteCourses
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_archive_course_modal) ? _c('dialog-delete-confirm', {
    attrs: {
      "header": "Are you sure want to archive this",
      "submitButton": "ARCHIVE",
      "labelText": "Please type in \"confirm\" to archive this item",
      "subHeader": "Archiving this course will stop students from being able to see or enter the course, and it will move this course to the bottom of the list on your dashboard. You can restore the course at any time.",
      "optionalText": "Course"
    },
    on: {
      "close": function($event) {
        _vm.show_archive_course_modal = false
      },
      "actionConfirmed": _vm.archiveCourse
    }
  }) : _vm._e()]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-71496767!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/courses/coursesTable.vue
// module id = 2081
// module chunks = 61